import { mapGetters } from 'vuex'

import data from '@/mixins/data'
import methods from '@/mixins/methods'

import TitleAnimation from '@/components/ui/title-animation'
import LinkAnimation from '@/components/ui/link-animation'
import TextAnimation from '@/components/ui/text-animation'
import HashtagAnimation from '@/components/ui/hashtag-animation'
import ImageAnimation from '@/components/ui/image-animation'
import Wysiwyg from '@/components/wysiwyg'

import { getCleanLink, getImageUrl, getFeaturedImageFromPost, nl2br, extractYoutubeId, extractVimeoId } from '@/helpers'

export default {
  mixins: [data, methods],
  props: {
    data: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  created () {
    let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    this.mobile = this.$store.state.ua.platform.type !== 'desktop' || isSafari
  },
  components: {
    TitleAnimation,
    LinkAnimation,
    TextAnimation,
    HashtagAnimation,
    ImageAnimation,
    Wysiwyg
  }
}
